import _axios from "../api";
const API = {
  getList: "notification/list",
  typeList: "notification/type-list",
  action: "notification/action",
  filterAction: "notification/filter-action"
};

export const getNotificationList = async (qry) => {
  const response = await _axios.get(`${API.getList}${qry}`);
  return response.data;
};
export const getAllNotificationTypeWise = async (qry) => {
  const response = await _axios.get(`${API.typeList}${qry}`);
  return response.data;
};
export const updateActionForNotification = async (model) => {
  const response = await _axios
    .put(API.action, model)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateFilterActionForNotification = async (model) => {
  const response = await _axios
    .put(API.filterAction, model)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getNotificationSetting = async () => {
  const response = await _axios.get(`notification/setting`);
  return response.data;
};

export const saveNotificationSettings = async (model) => {
  const response = await _axios.put(`notification/setting`, model);
  return response.data;
};

export const updateNotificationAction = async (model) => {
  const response = await _axios.put(`notification/action`, model);
  return response.data;
};

export const updateNotificationFilterAction = async (model) => {
  const response = await _axios.put(`notification/filter-action`, model);
  return response.data;
};

export const getNotificationFilterList = async () => {
  const response = await _axios.get(`notification/filter`);
  return response.data;
};

export const getNotificationUnreadCount = async () => {
  const response = await _axios.get(`notification/unreadcount`);
  return response.data;
};
